// Created by carsonaberle at 1/17/22
export const orderNow = 'order now';
export const sectionHeaderTitle = 'listing services';
export const sectionHeaderSubtitle = 'browse by type';
